import { defineStore } from 'pinia'

import type { CheckoutStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCheckoutStore = defineStore('checkout', {
  state: (): CheckoutStore => ({
    loading: false,
    paymentLocked: false,
    appliesForPromocode: false,
    furtherPayments: [],
    order: null,
    upsellOrder: null,
    paymentData: null,
    stripeClientSecret: null,
    paypalScriptUrl: null,
    modalFurtherPayments: false,
    blockPromoCode: false,
    paypalScriptReady: false,
    paymentError: false,
    notifyType: null,
    modalPaymentFailed: true,
    billingCountry: 'US',
    billingZipCode: '',
    billingCountryState: 'normal',
    billingZipStatus: undefined,
    billingConfirmed: false,
    modalFormSolidgate: false,
    modalCurrentMethodPayment: false,
  }),
  actions,
  getters,
})
